module.exports = __webpack_public_path__ + "static/media/img-goal-10.3dcd23ab.jpg";